module.exports = __webpack_public_path__ + "img/pic_france_08.032e154a.jpg";